export const PRIORITY = [
    { label: 'Low', value: 'low' },
    { label: 'Medium', value: 'medium' },
    { label: 'High', value: 'high' },
];

export const COLORS = {
    low: '#9dbde5',
    medium: '#f59f01',
    high: '#db5959'
}